function detectLocal() {
    var returnVal = false;
    var currentUrl = window.location.origin;

    if (currentUrl.includes("local") || currentUrl.includes("127.0")) {
        returnVal = true;
    } else {
        returnVal = false;
    }
    return returnVal;
}

// false =>  배포용
// true => 개발용
export const env =  {
    API_URL: detectLocal()
        ? "http://localhost:8580"
        : "http://165.243.102.104:8580",

    // 바코드 크롬 cors 해제 주소
    // chrome://flags/#block-insecure-private-network-requests
    // disabled로 설정
};

